import React, { memo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';

import TemplateCreateLetterContent from '@/views/pages/Template/elements/TemplateCreateLetterContent';

import Tab from '@/views/components/Tab/Tab';

const TemplateCreateLetterWrapper = ({ availableModes }) => {
	const { dict } = useSelector((state) => state.app);
	const dictLetter = dict.letter;

	const [ currentMode, setCurrentMode ] = useState(null);
	const [ hidden, setHidden ] = useState(false);

	const availableModesLength = availableModes && availableModes.length;
	const isAvailableModeExists = availableModesLength && availableModesLength !== 0; 

	const isMobile = useWindowIsMobile(991);

	useEffect(() => {
		if (isAvailableModeExists) {
			setCurrentMode(availableModes[0].mode);
		}
	}, [ availableModes ]);

	const currentModeContent = availableModes && availableModes.find((availableMode) => availableMode.mode === currentMode);
	const currentContent = currentModeContent && currentModeContent.content;

	if (!hidden) {
		return (
			<div className='letter__text--container'>
				{!isMobile && <div className='letter__text--header noselect'>
					<div className='letter__text--mode-selector'>
						{
							isAvailableModeExists && availableModes.map((availableMode) => {
								const { mode } = availableMode;
								return (
									<Tab 
										key={ mode }
										isBtn={ availableModesLength > 1 }
										isTabActive={ mode  === currentMode }
										onClickHandler={ setCurrentMode }
										value={ mode }
										label={ mode === 'finalDoc' ? dictLetter['modelDoc'] : dictLetter[mode] }
										style={ { borderRight: 'solid 1px #D9D9D9' } }
									/>
								);
							})
						}

						{currentModeContent && currentContent && (
							<div className='letter__text--info'>
								<span style={ { fontWeight: '500' } }>{dictLetter.characters}&nbsp;</span>{currentContent.characters}
							</div>
						)}

					</div>
				</div>}
				{ currentModeContent && (
					<div className='letter__text--content'>
						<TemplateCreateLetterContent
							currentModeContent={ currentModeContent }
						/>
						{!isMobile && <div 
							className='letter__text--hide-button'
							onClick={ () => { setHidden(true); } }
						>
							<i className='icon-arrow-left-full' />
						</div>}
					</div>
				)}
			</div>
		);
	} else if (!isMobile) {
		return (
			<div 
				className='letter__text--hide-button'
				onClick={ () => { setHidden(false); } }
			>
				<i className='icon-arrow-right-full' />
			</div>
		);
	}

	return <></>;
};

export default memo(TemplateCreateLetterWrapper);